import { coalescedGet } from "@/lib/http";
import type { DeviceDashboardResponse } from "../devices/types";
import {
  buildMachineDashboard,
  buildMachineSummary,
  buildMachineSidebarSummary,
  DEV_MACHINE_ID,
  type MachineDashboard,
  type MachineSidebarSummary,
  type MachineSummary,
  type DeviceStructure,
} from "./projection";

export async function listWorkspaceMachines(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<MachineSummary[]> {
  const { devices } = await getWorkspaceStructure(workspaceId, signal);
  return devices.length > 0 ? [buildMachineSummary(workspaceId, devices)] : [];
}

export async function getMachineDashboard(
  workspaceId: string,
  machineId: string,
  signal?: AbortSignal,
): Promise<MachineDashboard> {
  if (machineId !== DEV_MACHINE_ID) {
    throw new Error(`Maquina '${machineId}' ainda nao existe no dev-store.`);
  }

  const { dashboards } = await getWorkspaceDashboard(workspaceId, signal);

  return buildMachineDashboard(workspaceId, dashboards);
}

export async function getMachineSidebarSummary(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<MachineSidebarSummary> {
  const { devices } = await getWorkspaceStructure(workspaceId, signal);
  return buildMachineSidebarSummary(workspaceId, devices);
}

function getWorkspaceStructure(workspaceId: string, signal?: AbortSignal) {
  return coalescedGet<{ devices: DeviceStructure[] }>(
    `/api/workspaces/${encodeURIComponent(workspaceId)}/structure`, signal,
  );
}

function getWorkspaceDashboard(workspaceId: string, signal?: AbortSignal) {
  return coalescedGet<{ dashboards: DeviceDashboardResponse[] }>(
    `/api/workspaces/${encodeURIComponent(workspaceId)}/dashboard`, signal,
  );
}
